import { axiosService } from '..';

export default class GetOrganizationBusinessPricingsFromMainProject {
    public async execute(businessId: number): Promise<GetOrganizationBusinessPricingsFromMainProjectDto[]> {
        const pricings = (await axiosService.instance.get(`businesses/organization/${businessId}/pricings-from-main-project`)).data;
        return pricings.map((pricing: any) => new GetOrganizationBusinessPricingsFromMainProjectDto(pricing));
    }
}

export class GetOrganizationBusinessPricingsFromMainProjectDto {
    public readonly pricingId: number;
    public readonly projectId: number;
    public readonly name: string;
    public readonly description: string | null;
    public readonly isBusinessSubscribedTo: boolean;
    public readonly priceBase: number;
    public readonly discount: number;
    public readonly priceFinal: number;
    public readonly namesToDisplay: GetOrganizationBusinessPricingsFromMainProjectNameToDisplayDto[];
    public readonly descriptionsToDisplay: GetOrganizationBusinessPricingsFromMainProjectDescriptionToDisplayDto[];
    public readonly level: number;
    public readonly visibility: VisibilityModes;

    constructor(data: any) {
        this.pricingId = data.pricingId;
        this.projectId = data.projectId;
        this.name = data.name;
        this.description = data.description;
        this.isBusinessSubscribedTo = data.isBusinessSubscribedTo;
        this.priceBase = data.priceBase;
        this.level = data.level;
        this.discount = data.discount;
        this.priceFinal = data.priceFinal;
        this.namesToDisplay = data.namesToDisplay.map((nameToDisplay: any) => new GetOrganizationBusinessPricingsFromMainProjectNameToDisplayDto(nameToDisplay));
        this.descriptionsToDisplay = data.descriptionsToDisplay.map((descriptionToDisplay: any) => new GetOrganizationBusinessPricingsFromMainProjectDescriptionToDisplayDto(descriptionToDisplay));
        this.level = data.level;
        this.visibility = data.visibility;
    }
}

export class GetOrganizationBusinessPricingsFromMainProjectNameToDisplayDto {
    public readonly name: string;
    public readonly culture: string;

    constructor(data: any) {
        this.name = data.name;
        this.culture = data.culture;
    }
}

export class GetOrganizationBusinessPricingsFromMainProjectDescriptionToDisplayDto {
    public readonly description: string;
    public readonly culture: string;

    constructor(data: any) {
        this.description = data.description;
        this.culture = data.culture;
    }
}

export enum VisibilityModes {
    NoRestriction = 0,
    HideInSubscriptionPage = 1
}

export const getOrganizationBusinessPricingsFromMainProject = new GetOrganizationBusinessPricingsFromMainProject();
